import { RestrictedLink } from "../../routes";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import "./FooterLine.scoped.scss";

export default function FooterLine() {
  return (
    <div className="root flex py-4">
      <div className="w-1/5 sm:text-sm text-xs flex items-center justify-center">
        <RestrictedLink
          className="flex items-center"
          to="/"
          onClick={() => window.scroll({ top: 0, behavior: "smooth" })}
        >
          <FaCaretLeft /> トップ
        </RestrictedLink>
      </div>
      <div className="w-3/5 sm:text-sm text-xs">
        ©2021 有志アキネコ一同/
        <br className="inline md:hidden" />
        鈴谷アキ誕生日企画2021（非公式）
      </div>
      <div className="w-1/5 sm:text-sm text-xs flex items-center justify-center">
        <a
          className="flex items-center"
          href="https://akikunsuki.com/"
          target="_blank"
          rel="noreferrer"
        >
          ポータル <FaCaretRight />
        </a>
      </div>
    </div>
  );
}
